
import PropTypes from 'prop-types'
import React from 'react'
import { FlexGrid as Grid, FlexItem as Item } from '../flexgrid'
import Sheet from '../Sheet'
import Space from '../Space'
import './sheet.css'

const InfoSheet = props => {
  const { title, subtitle, image, onClose } = props
  return (
    <Sheet onClose={onClose} isPadded={false} wide>
      <div className='InfoSheet'>
        <header className='InfoSheet-header'>
          <Grid>
            <Item width={180} spaceRight={30}>
              <div className='InfoSheet-logo'>
                <img alt={title} src={image} />
              </div>
            </Item>
            <Item width={520}>
              <div className='InfoSheet-title'>
                <h2>{title}</h2>
                <Space value='5' />
                <p>{subtitle}</p>
              </div>
            </Item>
          </Grid>
        </header>
        <Grid>
          {props.children}
        </Grid>
      </div>
    </Sheet>
  )
}

InfoSheet.propTypes = {
  children: PropTypes.array.isRequired,
  image: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
}

InfoSheet.displayName = 'InfoSheet'

export default InfoSheet



// WEBPACK FOOTER //
// ./ui/InfoSheet/sheet.js